module.exports = __webpack_public_path__ + "img/404-bg.png?b3d15d69c2b9c4cb714d9aebff3975f0";